<template>
    <div id="main" class="container">        
        <div v-if="!lessons" class="loading-wrapper">
            <div class="loading"></div>
        </div>
        <div class="row">
            <div class="col-lg-2 side-column">
                <Sidebar :siteMenu="siteMenu" @checkedFilters="filters = $event" @searchText="searchValue = $event" />
            </div>
            <div class="col-lg-9 offset-lg-1 main-column">
                <Content :lessons="lessons" :activeFilters="filters" :activeSearch="searchValue" />
            </div>
        </div>
    </div>
</template>

<script>
import Content from './Content.vue';
import Sidebar from './Sidebar.vue';


export default {
    name: "Main",
    props: ["lessons", "siteMenu"],
    data() {
        return {
            filters: [],
            searchValue: ""
        }
    },
    components: {
        Content,
        Sidebar
    }
}
</script>

<style lang="scss">
@media (min-width: 992px) {
    #main .side-column {
        position: relative;
        &:after {
            content: '';
            position: absolute;
            top: 1rem;
            bottom: 0;
            left: 125%;
            width: 1px;
            background-color: var(--color-hilight-orange);
        }
    }
}

.loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;

    .loading {
        width: 164px;
        height: 155px;
        background: url("../assets/loading.gif") no-repeat center center;
    }

}

#content, #sidebar {
    margin-top: 50px;
}
</style>